import { updateProfileAction } from '../update'
import { PROFILES_ACTION } from '../../constants'
import { PROFILE_KEY } from '../../../../../models/profile/constants'

export function updateBirthdayProfileAction (value) {
  return updateProfileAction({
    type: PROFILES_ACTION.UPDATE_BIRTHDAY,
    payload: {
      key: PROFILE_KEY.BIRTHDAY,
      value
    }
  })
}
